var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { request as __request } from '../core/request';
export class PresentationService {
    /**
     * Find prezi objects
     * @returns Prezi prezi list
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentation({ ownerId, ownerIdIn, oid, oidIn, schemaVersion, schemaVersionIn, modifiedAt, modifiedAtGt, modifiedAtLt, modifiedAtGte, modifiedAtLte, public: publicProp, showcaseProhibited, privacy, mine, shared, mineShared, groupUuid, ordering, offset, limit, includeUserPermissions, fields, withoutChildrenOfKinds, tag, tagNot, tagIn, tagNotIn, videoStatus, videoStatusIn, videoStatusInOrNull, titleIcontains, filterAirAndAirVideoForDashboard, likedByMe, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/`,
                query: {
                    'owner_id': ownerId,
                    'owner_id__in': ownerIdIn,
                    'oid': oid,
                    'oid__in': oidIn,
                    'schema_version': schemaVersion,
                    'schema_version__in': schemaVersionIn,
                    'modified_at': modifiedAt,
                    'modified_at__gt': modifiedAtGt,
                    'modified_at__lt': modifiedAtLt,
                    'modified_at__gte': modifiedAtGte,
                    'modified_at__lte': modifiedAtLte,
                    'public': publicProp,
                    'showcase_prohibited': showcaseProhibited,
                    'privacy': privacy,
                    'mine': mine,
                    'shared': shared,
                    'mine+shared': mineShared,
                    'group_uuid': groupUuid,
                    'ordering': ordering,
                    'offset': offset,
                    'limit': limit,
                    'include_user_permissions': includeUserPermissions,
                    'fields': fields,
                    'without_children_of_kinds': withoutChildrenOfKinds,
                    'tag': tag,
                    'tag_not': tagNot,
                    'tag__in': tagIn,
                    'tag_not__in': tagNotIn,
                    'video_status': videoStatus,
                    'video_status__in': videoStatusIn,
                    'video_status__in_or_null': videoStatusInOrNull,
                    'title__icontains': titleIcontains,
                    'filter_air_and_air_video_for_dashboard': filterAirAndAirVideoForDashboard,
                    'liked_by_me': likedByMe,
                },
                errors: {
                    400: `error in the parameters`,
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Updates a prezi list
     * @returns Prezi updated prezi list
     * @returns Error unexpected error
     * @throws ApiError
     */
    static createPresentation({ prezis, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'POST',
                path: `/presentation/`,
                body: prezis,
                errors: {
                    304: `not modified`,
                    403: `authentication failure`,
                },
            });
            return result.body;
        });
    }
    /**
     * List prezi objects with pagination info
     * @returns PreziList prezi list
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationList({ ownerId, ownerIdIn, oid, oidIn, schemaVersion, schemaVersionIn, modifiedAt, modifiedAtGt, modifiedAtLt, modifiedAtGte, modifiedAtLte, public: publicProp, showcaseProhibited, privacy, mine, shared, mineShared, groupUuid, ordering, offset, limit, includeUserPermissions, fields, withoutChildrenOfKinds, tag, tagNot, tagIn, tagNotIn, videoStatus, videoStatusIn, videoStatusInOrNull, titleIcontains, filterAirAndAirVideoForDashboard, likedByMe, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/list/`,
                query: {
                    'owner_id': ownerId,
                    'owner_id__in': ownerIdIn,
                    'oid': oid,
                    'oid__in': oidIn,
                    'schema_version': schemaVersion,
                    'schema_version__in': schemaVersionIn,
                    'modified_at': modifiedAt,
                    'modified_at__gt': modifiedAtGt,
                    'modified_at__lt': modifiedAtLt,
                    'modified_at__gte': modifiedAtGte,
                    'modified_at__lte': modifiedAtLte,
                    'public': publicProp,
                    'showcase_prohibited': showcaseProhibited,
                    'privacy': privacy,
                    'mine': mine,
                    'shared': shared,
                    'mine+shared': mineShared,
                    'group_uuid': groupUuid,
                    'ordering': ordering,
                    'offset': offset,
                    'limit': limit,
                    'include_user_permissions': includeUserPermissions,
                    'fields': fields,
                    'without_children_of_kinds': withoutChildrenOfKinds,
                    'tag': tag,
                    'tag_not': tagNot,
                    'tag__in': tagIn,
                    'tag_not__in': tagNotIn,
                    'video_status': videoStatus,
                    'video_status__in': videoStatusIn,
                    'video_status__in_or_null': videoStatusInOrNull,
                    'title__icontains': titleIcontains,
                    'filter_air_and_air_video_for_dashboard': filterAirAndAirVideoForDashboard,
                    'liked_by_me': likedByMe,
                },
                errors: {
                    400: `error in the parameters`,
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Find prezi objects - same as /presentation/ but supports POST + JSON in the body, same parameters supported as in the GET-based endpoint
     * @returns Prezi prezi list
     * @returns Error unexpected error
     * @throws ApiError
     */
    static presentationSearch({ searchPresentationData, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'POST',
                path: `/presentation/search/`,
                body: searchPresentationData,
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Creates new presentation
     * @returns Prezi created Presentation
     * @returns Error unexpected error
     * @throws ApiError
     */
    static presentationCreate({ createPresentationData, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'POST',
                path: `/presentation/create/`,
                body: createPresentationData,
                errors: {
                    400: `Invalid input`,
                    403: `authentication failure`,
                },
            });
            return result.body;
        });
    }
    /**
     * Transfer multiple presentation objects from a user to another one
     * @returns Prezi prezi list
     * @returns Error unexpected error
     * @throws ApiError
     */
    static presentationTransfer({ transferPresentationData, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'POST',
                path: `/presentation/transfer/`,
                body: transferPresentationData,
                errors: {
                    400: `Invalid input`,
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Find a prezi object by the oid
     * @returns Prezi Prezi object
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationItem({ oid, authKey, keyType, includeUserPermissions, fields, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/${oid}/`,
                query: {
                    'auth_key': authKey,
                    'key_type': keyType,
                    'include_user_permissions': includeUserPermissions,
                    'fields': fields,
                },
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Delete a prezi object by the oid
     * @returns any Presentation successfully deleted
     * @returns Error unexpected error
     * @throws ApiError
     */
    static deletePresentationItem({ oid, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'DELETE',
                path: `/presentation/${oid}/`,
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Update a prezi object
     * @returns Prezi Prezi object
     * @returns Error unexpected error
     * @throws ApiError
     */
    static updatePresentationItem({ oid, prezi, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'PUT',
                path: `/presentation/${oid}/`,
                body: prezi,
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Creates a new prezi version with the content of a previous revision
     * @returns Prezi the updated Prezi object
     * @returns Error unexpected error
     * @throws ApiError
     */
    static createPresentationItemRevert({ oid, version, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'POST',
                path: `/presentation/${oid}/revert/`,
                body: version,
                errors: {
                    400: `Bad arguments supplied, eg: version is not a number or larger than the current`,
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * search for permissions for a given prezi
     * @returns UserPermissions Permission objects
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationItemPermissions({ oid, userIdIn, authKey, keyType, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/${oid}/permissions/`,
                query: {
                    'user_id__in': userIdIn,
                    'auth_key': authKey,
                    'key_type': keyType,
                },
                errors: {
                    403: `authentication failure`,
                    404: `prezi or user not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * get the permissions of a user for a prezi
     * @returns UserPermissions Permission object
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationItemPermissionsItem({ oid, userId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/${oid}/permissions/${userId}/`,
                errors: {
                    403: `authentication failure`,
                    404: `prezi or user not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Changes/adds permissions of a user
     * @returns UserPermissions Permission object after applying the change
     * @returns Error unexpected error
     * @throws ApiError
     */
    static updatePresentationItemPermissionsItem({ oid, userId, permission, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'PUT',
                path: `/presentation/${oid}/permissions/${userId}/`,
                body: permission,
                errors: {
                    403: `authentication failure`,
                    404: `prezi or user not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Removes permissions from a user
     * @returns any Deleted
     * @returns Error unexpected error
     * @throws ApiError
     */
    static deletePresentationItemPermissionsItem({ oid, userId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'DELETE',
                path: `/presentation/${oid}/permissions/${userId}/`,
                errors: {
                    403: `authentication failure`,
                    404: `prezi or user not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * get the prezi and the permissions together for a user - NOT IMPLEMENTED YET
     * @returns PreziBundle Prezi bundle object
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationItemWithPermissionsItem({ oid, userId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/${oid}/with_permissions/${userId}/`,
                errors: {
                    403: `authentication failure`,
                    404: `prezi or user not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * get the generic (create) permissions of the authenticated user
     * @returns PermissionsForUser Permission object
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationPermissionsForUser({ schemaVersionIn, permissionIn, permissionPrefix, permissionContains, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/permissions-for-user/`,
                query: {
                    'schema_version__in': schemaVersionIn,
                    'permission__in': permissionIn,
                    'permission_prefix': permissionPrefix,
                    'permission_contains': permissionContains,
                },
                errors: {
                    403: `authentication failure`,
                    404: `prezi or user not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * get the permissions of the authenticated user for a prezi
     * @returns PermissionsForDocumentAndUser Permission object
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationItemPermissionsForUser({ oid, permissionIn, permissionPrefix, permissionContains, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/${oid}/permissions-for-user/`,
                query: {
                    'permission__in': permissionIn,
                    'permission_prefix': permissionPrefix,
                    'permission_contains': permissionContains,
                },
                errors: {
                    403: `authentication failure`,
                    404: `prezi or user not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * get the unified privacy data along with the detailed permissions for a document
     * @returns UnifiedPrivacy Unified Privacy object
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationItemUnifiedPrivacy({ oid, excludePermissions, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/${oid}/unified-privacy/`,
                query: {
                    'exclude_permissions': excludePermissions,
                },
                errors: {
                    403: `authentication failure`,
                    404: `prezi or user not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * set the unified privacy of a document
     * @returns UnifiedPrivacy Unified Privacy object
     * @returns Error unexpected error
     * @throws ApiError
     */
    static updatePresentationItemUnifiedPrivacy({ oid, unifiedPermission, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'PUT',
                path: `/presentation/${oid}/unified-privacy/`,
                body: unifiedPermission,
                errors: {
                    403: `authentication failure`,
                    404: `prezi or user not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Get a list of tokens for a presentation
     * @returns StorageToken list of storage token objects
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationItemToken({ oid, authKey, keyType, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/${oid}/token/`,
                query: {
                    'auth_key': authKey,
                    'key_type': keyType,
                },
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Get a specific token for a presentation
     * @returns StorageToken Storage token object
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationItemTokenTokenType({ oid, tokenType, authKey, keyType, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/${oid}/token/${tokenType}/`,
                query: {
                    'auth_key': authKey,
                    'key_type': keyType,
                },
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Prezi object id -> oid converter
     * @returns string Prezi oid
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationId2OidItem({ id }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/id2oid/${id}/`,
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Prezi object oid -> id converter
     * @returns number Prezi id
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationOid2IdItem({ oid }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/oid2id/${oid}/`,
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * create prezis for a given user
     * @returns Prezi prezi list
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationTestCreatePresentations({ ownerId, count, privacy, preziTitle, preziDescription, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/test/create_presentations/`,
                query: {
                    'owner_id': ownerId,
                    'count': count,
                    'privacy': privacy,
                    'prezi_title': preziTitle,
                    'prezi_description': preziDescription,
                },
            });
            return result.body;
        });
    }
    /**
     * Get the number of presentations
     * @returns PreziCount prezi counts
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationCount({ schemaVersion, includeFolderCounts, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/count/`,
                query: {
                    'schema_version': schemaVersion,
                    'include-folder-counts': includeFolderCounts,
                },
            });
            return result.body;
        });
    }
    /**
     * Get the number of presentations
     * @returns PreziDetailedCount prezi counts
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationDetailedCount({ ownerIn, privacyIn, schemaVersionIn, withoutChildrenOfKinds, filterAirAndAirVideoForDashboard, titleIcontains, tagNotIn, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/detailed-count/`,
                query: {
                    'owner__in': ownerIn,
                    'privacy__in': privacyIn,
                    'schema_version__in': schemaVersionIn,
                    'without_children_of_kinds': withoutChildrenOfKinds,
                    'filter_air_and_air_video_for_dashboard': filterAirAndAirVideoForDashboard,
                    'title__icontains': titleIcontains,
                    'tag_not__in': tagNotIn,
                },
            });
            return result.body;
        });
    }
    /**
     * Get user statistics
     * @returns UserStatistics prezi counts
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationUserStatistics() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/user-statistics/`,
            });
            return result.body;
        });
    }
    /**
     * get the parent relations for a presentation (relations where the specified oid is a child), not allowed for users
     * @returns PresentationRelationsLookupResult parent relations
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationItemRelationParent({ oid, relationKind, relationKindIn, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/${oid}/relation/parent/`,
                query: {
                    'relation_kind': relationKind,
                    'relation_kind__in': relationKindIn,
                },
            });
            return result.body;
        });
    }
    /**
     * add a parent relation for the specified oid with that document as child
     * @returns PresentationRelation the created relation
     * @returns Error unexpected error
     * @throws ApiError
     */
    static createPresentationItemRelationParent({ oid, body, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'POST',
                path: `/presentation/${oid}/relation/parent/`,
                body: body,
            });
            return result.body;
        });
    }
    /**
     * get the child relations for a presentation (relations where the specified oid is a parent), not allowed for users
     * @returns PresentationRelationsLookupResult child relations
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationItemRelationChild({ oid, relationKind, relationKindIn, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/${oid}/relation/child/`,
                query: {
                    'relation_kind': relationKind,
                    'relation_kind__in': relationKindIn,
                },
            });
            return result.body;
        });
    }
    /**
     * add a child relation for the specified oid with that document as parent
     * @returns PresentationRelation the created relation
     * @returns Error unexpected error
     * @throws ApiError
     */
    static createPresentationItemRelationChild({ oid, body, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'POST',
                path: `/presentation/${oid}/relation/child/`,
                body: body,
            });
            return result.body;
        });
    }
    /**
     * List tags on prezi objects with a similar but smaller set of filters like prezi list
     * @returns TagLookupResult tag list
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationTag({ ownerId, ownerIdIn, schemaVersion, schemaVersionIn, modifiedAt, modifiedAtGt, modifiedAtLt, modifiedAtGte, modifiedAtLte, public: publicProp, showcaseProhibited, privacy, mine, shared, mineShared, groupUuid, ordering, offset, limit, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/tag/`,
                query: {
                    'owner_id': ownerId,
                    'owner_id__in': ownerIdIn,
                    'schema_version': schemaVersion,
                    'schema_version__in': schemaVersionIn,
                    'modified_at': modifiedAt,
                    'modified_at__gt': modifiedAtGt,
                    'modified_at__lt': modifiedAtLt,
                    'modified_at__gte': modifiedAtGte,
                    'modified_at__lte': modifiedAtLte,
                    'public': publicProp,
                    'showcase_prohibited': showcaseProhibited,
                    'privacy': privacy,
                    'mine': mine,
                    'shared': shared,
                    'mine+shared': mineShared,
                    'group_uuid': groupUuid,
                    'ordering': ordering,
                    'offset': offset,
                    'limit': limit,
                },
                errors: {
                    400: `error in the parameters`,
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * sets (replaces all current) tags for a presentation
     * @returns Tags the created tags
     * @returns Error unexpected error
     * @throws ApiError
     */
    static updatePresentationItemTag({ oid, tags, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'PUT',
                path: `/presentation/${oid}/tag/`,
                body: tags,
            });
            return result.body;
        });
    }
    /**
     * Sets or updates the curation for a given content
     * @returns CuratedContent the created CuratedContent
     * @returns Error unexpected error
     * @throws ApiError
     */
    static createPresentationItemCuratedContent({ oid, curatedContent, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'POST',
                path: `/presentation/${oid}/curated-content/`,
                body: curatedContent,
            });
            return result.body;
        });
    }
    /**
     * Gets the curation for a given content
     * @returns CuratedContent the existing CuratedContent
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationItemCuratedContent({ oid, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/${oid}/curated-content/`,
                errors: {
                    404: `Curated content not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Deletes the curation for a given content
     * @returns any Curation successfully deleted
     * @returns Error unexpected error
     * @throws ApiError
     */
    static deletePresentationItemCuratedContent({ oid, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'DELETE',
                path: `/presentation/${oid}/curated-content/`,
                errors: {
                    404: `Curated content not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Get the curated topic
     * @returns CuratedTopic list of curated topics
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationCuratedTopic() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/curated-topic/`,
            });
            return result.body;
        });
    }
    /**
     * Like a presentation
     * @returns LikeCount Like count
     * @returns Error unexpected error
     * @throws ApiError
     */
    static updatePresentationItemLike({ oid, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'PUT',
                path: `/presentation/${oid}/like/`,
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Unlike (or delete a like for) a presentation
     * @returns LikeCount Like count
     * @returns Error unexpected error
     * @throws ApiError
     */
    static deletePresentationItemLike({ oid, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'DELETE',
                path: `/presentation/${oid}/like/`,
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Like a presentation
     * @returns LikeCount Like count
     * @returns Error unexpected error
     * @throws ApiError
     */
    static updatePresentationLike({ authKey, keyType, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'PUT',
                path: `/presentation/like/`,
                query: {
                    'auth_key': authKey,
                    'key_type': keyType,
                },
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Unlike (or delete a like for) a presentation
     * @returns LikeCount Like count
     * @returns Error unexpected error
     * @throws ApiError
     */
    static deletePresentationLike({ authKey, keyType, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'DELETE',
                path: `/presentation/like/`,
                query: {
                    'auth_key': authKey,
                    'key_type': keyType,
                },
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Set view count
     * @returns ViewCountPutSuccess ViewCountPutSuccess
     * @returns Error unexpected error
     * @throws ApiError
     */
    static updatePresentationItemViewCount({ oid, viewCount, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'PUT',
                path: `/presentation/${oid}/view-count/`,
                body: viewCount,
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Bulk set view count
     * @returns ViewCountBulkPutSuccess ViewCountPutSuccess
     * @returns Error unexpected error
     * @throws ApiError
     */
    static updatePresentationViewCount({ updates, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'PUT',
                path: `/presentation/view-count/`,
                body: updates,
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Bulk set quality score v2
     * @returns QualityScoreV2BulkPutSuccess QualityScoreV2PutSuccess
     * @returns Error unexpected error
     * @throws ApiError
     */
    static updatePresentationQualityScoreV2({ updates, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'PUT',
                path: `/presentation/quality-score-v2/`,
                body: updates,
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Query a single invitation metadata
     * @returns InvitationMeta Invitation metadata
     * @throws ApiError
     */
    static getPresentationInvitationItem({ invitationId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/invitation/${invitationId}/`,
            });
            return result.body;
        });
    }
    /**
     * Called on auth user creation and changes all pending invitation to permissions
     * @returns InvitationAccepted All pending invitations changed to real ones
     * @throws ApiError
     */
    static createPresentationInvitation({ invitationAccept, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'POST',
                path: `/presentation/invitation/`,
                body: invitationAccept,
            });
            return result.body;
        });
    }
    /**
     * Called when a user requests access to a project they don't have access to
     * @returns AccessRequestResult Access request sent
     * @throws ApiError
     */
    static createPresentationItemAccessRequest({ oid, accessRequest, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'POST',
                path: `/presentation/${oid}/access-request/`,
                body: accessRequest,
            });
            return result.body;
        });
    }
    /**
     * Get oid from sentprezi token
     * @returns SentPreziResult Sentprezi token validated, returning the prezi's oid
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationSentpreziToken({ token, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation/sentprezi/${token}/`,
                errors: {
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Find deleted prezi objects
     * @returns DeletedPrezi deleted prezi list
     * @returns Error unexpected error
     * @throws ApiError
     */
    static getPresentationDeleted({ ownerId, ownerIdIn, oidIn, public: publicProp, showcaseProhibited, privacy, ordering, offset, limit, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/presentation-deleted/`,
                query: {
                    'owner_id': ownerId,
                    'owner_id__in': ownerIdIn,
                    'oid__in': oidIn,
                    'public': publicProp,
                    'showcase_prohibited': showcaseProhibited,
                    'privacy': privacy,
                    'ordering': ordering,
                    'offset': offset,
                    'limit': limit,
                },
                errors: {
                    400: `error in the parameters`,
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Permanently delete all the prezi data from the DeletedPresentation objects for the authenticated user
     * @returns Error unexpected error
     * @returns any Done
     * @throws ApiError
     */
    static deletePresentationDeleted() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'DELETE',
                path: `/presentation-deleted/`,
                errors: {
                    403: `authentication failure`,
                },
            });
            return result.body;
        });
    }
    /**
     * Permanently delete the prezi data from the DeletedPresentation objects
     * @returns Error unexpected error
     * @returns any Done
     * @throws ApiError
     */
    static deletePresentationDeletedItem({ oid, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'DELETE',
                path: `/presentation-deleted/${oid}/`,
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
    /**
     * Recover the prezi data from the DeletedPresentation objects and assign owner permissions
     * @returns Prezi Prezi object
     * @returns Error unexpected error
     * @throws ApiError
     */
    static createPresentationDeletedItemRestore({ oid, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'POST',
                path: `/presentation-deleted/${oid}/restore/`,
                errors: {
                    403: `authentication failure`,
                    404: `prezi not found`,
                },
            });
            return result.body;
        });
    }
}
